import {
  alpha,
  Box,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useState } from "react";
import {
  Cloud as CloudIcon,
  MoreHoriz as MoreHorizIcon,
  Search as SearchIcon,
  SwapVert as SwapVertIcon,
} from "@mui/icons-material";

function Header({
  search,
  onSearchChange,
  setShowProgressDialog,
}: {
  search: string;
  onSearchChange: (newSearch: string) => void;
  setShowProgressDialog: (show: boolean) => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <Box sx={{ px: 2, pt: 1.5, pb: 1 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
        <CloudIcon color="primary" sx={{ fontSize: 28, mr: 1 }} />
        <Typography variant="h6" sx={{ fontWeight: 700, flexGrow: 1 }}>
          家庭网盘
        </Typography>
        <IconButton
          aria-label="更多"
          color="inherit"
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <MoreHorizIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              setShowProgressDialog(true);
            }}
          >
            <SwapVertIcon fontSize="small" sx={{ mr: 1 }} />
            传输进度
          </MenuItem>
        </Menu>
      </Box>
      <InputBase
        size="small"
        fullWidth
        placeholder="搜索文件"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        startAdornment={
          <SearchIcon
            fontSize="small"
            sx={{ mr: 1, color: "text.disabled" }}
          />
        }
        sx={{
          backgroundColor: (theme) =>
            alpha(theme.palette.text.primary, 0.06),
          borderRadius: "999px",
          padding: "6px 16px",
          fontSize: "0.9rem",
        }}
      />
    </Box>
  );
}

export default Header;
